export default __webpack_public_path__ + "static/lincoln-30083a5bf1bd216a3fe610aa834c3dfc.png";